import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

const uri = process.env.GATSBY_GRAPHQL_API_URL;

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({ uri }),
  ssrMode: typeof window === 'undefined',
});
